export function evaluateEquation(equation: string | undefined, x: number): number | undefined {
    if(!equation) 
        return undefined
    equation = equation.trim();

    let y: number | null = null;

    if (/log/.test(equation)) { // Logarithmic
        const match = /y\s*=\s*([\d\.\-]+)\s*\+\s*([\d\.\-]+)\s*\*\s*log\(\s*x\s*\)/.exec(equation);
        if (match) {
            const a = parseFloat(match[1]);
            const b = parseFloat(match[2]);
            y = a + b * Math.log(x);
        }
    } else if (/e\^/.test(equation)) { // Exponential
        const match = /y\s*=\s*([\d\.\-]+)\s*\*\s*e\^\(\s*([\-\d\.]+)\s*\*?\s*x\)/.exec(equation);
        if (match) {
            const a = parseFloat(match[1]);
            const b = parseFloat(match[2]);
            y = a * Math.exp(b * x);
        }
    } else if (/x\^/.test(equation)) { // Power
        const match = /y\s*=\s*([\d\.\-]+)\s*\*\s*x\^\s*([\d\.\-]+)/.exec(equation);
        if (match) {
            const a = parseFloat(match[1]);
            const b = parseFloat(match[2]);
            y = a * Math.pow(x, b);
        }
    } else if (/[\+\-]\s*\d/.test(equation)) { // Linear
        const match = /y\s*=\s*([\-\d\.]+)x\s*([\+\-])\s*([\d\.\-]+)/.exec(equation);
        if (match) {
            const a = parseFloat(match[1]);
            const sign = match[2];
            const b = parseFloat(match[3]);
            y = a * x + (sign === '+' ? b : -b);
        }
    } else {
        return undefined;
    }

    return y !== null ? parseFloat(y.toFixed(4)) : undefined;
}
